import React, { useEffect } from "react"
import { Link } from "gatsby"
import { trackCustomEvent, OutboundLink } from "gatsby-plugin-google-analytics"
import logo from "../../images/logo.png"

import * as Styled from "../Icons/styled"
import { TopMenu, BottomMenu } from "../NavBar/styled"

function NavBar() {
  return (
    <>
      <TopMenu>
        <div className="container-top-menu">
          <div className="logo">
            <Link to="/">
              <img src={logo} className="image-logo" />
            </Link>
          </div>


          <ul className={"top-menu"}>
            <li>
              <Link activeStyle={{ color: "#FFF212" }} to="/">
                <Styled.HomeWrapper style={{ color: "#fff" }} />
                Início
              </Link>
            </li>
            <li>
              <Link activeStyle={{ color: "#FFF212" }} to="/services">
                <Styled.LibraryBooksWrapper style={{ color: "#fff" }} />
                Serviços
              </Link>
            </li>
            <li>
              <Link activeStyle={{ color: "#FFF212" }} to="/about">
                <Styled.LocationOnWrapper style={{ color: "#fff" }} />
                Escritório
              </Link>
            </li>
          </ul>
        </div>
      </TopMenu>

      <BottomMenu>
        <ul>
          <li>
            <Link activeStyle={{ color: "#FFF212" }} to="/">
              <Styled.HomeWrapper style={{ color: "#fff" }} />
              Início
            </Link>
          </li>
          <li>
            <Link activeStyle={{ color: "#FFF212" }} to="/services">
              <Styled.LibraryBooksWrapper style={{ color: "#fff" }} />
              Serviços
            </Link>
          </li>
          <li>
            <Link activeStyle={{ color: "#FFF212" }} to="/about">
              <Styled.LocationOnWrapper style={{ color: "#fff" }} />
              Escritório
            </Link>
          </li>
          <li>
            <OutboundLink
              onClick={e => {
                trackCustomEvent({
                  category: "Custom Button",
                  action: "Click",
                  label: "Botao do Whatsapp",
                })
              }}
              href="https://wa.me/5562984047472?text=Saudações!%20Solicito%20o%20seu%20atendimento."
              className="botao-zap-inferior"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Styled.WhatsappWrapper style={{ color: "#fff" }} />
              Zap!
            </OutboundLink>
          </li>
        </ul>
      </BottomMenu>
    </>
  )
}

export default NavBar
